const STORAGE_KEYS = {
  USER: 'talktastic_user',
  TOKEN: 'token',
  GAME_HISTORY: 'game_history',
  SETTINGS: 'settings'
};

const storage = {
  set(key, value) {
    try {
      const serializedValue = JSON.stringify(value);
      const storageKey = key === 'user' ? STORAGE_KEYS.USER : key;
      localStorage.setItem(storageKey, serializedValue);
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  },

  get(key) {
    try {
      const storageKey = key === 'user' ? STORAGE_KEYS.USER : key;
      const serializedValue = localStorage.getItem(storageKey);
      return serializedValue ? JSON.parse(serializedValue) : null;
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return null;
    }
  },

  remove(key) {
    try {
      const storageKey = key === 'user' ? STORAGE_KEYS.USER : key;
      localStorage.removeItem(storageKey);
    } catch (error) {
      console.error('Error removing from localStorage:', error);
    }
  },

  clear() {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  },

  clearOldData() {
    try {
      // 清除超过30天的游戏历史记录
      const history = this.get(STORAGE_KEYS.GAME_HISTORY) || [];
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
      
      const filteredHistory = history.filter(record => {
        const recordDate = new Date(record.timestamp);
        return recordDate > thirtyDaysAgo;
      });
      
      this.set(STORAGE_KEYS.GAME_HISTORY, filteredHistory);
    } catch (error) {
      console.error('Storage Cleanup Error:', error);
    }
  }
};

export { storage }; 